<template>
  <div>
  	<v-dialog v-model="dialog" persistent max-width="1024px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
            Agregar
        </v-btn>
      </template>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card>
          <v-card-title>
              <span class="text-h5">{{ formTitle }} - <span class="orange--text">{{ companyName }}</span></span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col col="12" md="3">
                    <v-autocomplete
                        v-model="virtualCard.billing_provider_id"
                        :rules="[v => !!v || 'Seleccione un proveedor']"
                        :items="providers"
                        item-text="name"
                        item-value="id"
                        label="Proveedor"
                        required @change="loadCurrency">

                        <template v-slot:no-data>
                            <div class="px-4" v-if="!virtualCard.owner_company_id">Seleccione una empresa</div>
                            <div class="px-4" v-else>Proveedor no encontrado</div>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="virtualCard.currency"
                    :rules= "[v => !!v || 'El tipo de divisa es requerido']"
                    label="Divisa"
                    required
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col col="12" md="3">
                    <v-select v-model="virtualCard.vendor_code"
                      :rules="[v => !!v || 'Emisor de tarjeta']"
                      :items="vendors_code"
                      item-text="name"
                      item-value="id"
                      label="Emisor de tarjeta"
                      required>
                    </v-select>
                </v-col>

                <v-col col="12" md="3">
                    <v-select v-model="virtualCard.type"
                      :rules="[v => !!v || 'El tipo de tarjeta es requerido']"
                      :items="card_types"
                      item-text="name"
                      item-value="id"
                      label="Tipo de tarjeta"
                      required>
                    </v-select>
                </v-col>
                <v-col col="12" md="3">
                  <v-select
                    v-model="virtualCard.cancellation_type"
                    :items="cancellations"
                    item-text="name"
                    item-value="id"
                    :rules="[v => !!v || 'Seleccione un tipo de cancelacion']"
                    label="Tipo de cancelaciones"
                    required>
                  </v-select>
                </v-col>
                <v-col col="12" md="3">
                  <v-select v-model="virtualCard.validity_period_start_type"
                  :items="itemsValidityStart"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v || 'Seleccione un tipo de inicio de validez']"
                  label="Inicio de validez"
                  required>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select v-model="virtualCard.validity_period_end_type"
                    :items="itemsValidityEnd"
                    item-text="name"
                    item-value="id"
                    :rules="[v => !!v || 'Seleccione un tipo de fin de validez']"
                    label="Fin de validez"
                    required>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="virtualCard.validity_end_interval"
                    min=0
                    label="Intervalo de fin de validez"
                    required
                    type="number">
                  </v-text-field>
                </v-col>

                 <v-col cols="12" md="3">
                  <v-select v-model="virtualCard.charge_date_type"
                    :items="chargeDateType"
                    item-text="name"
                    item-value="id"
                    :rules="[v => !!v || 'Selecciona la fecha de recarga']"
                    label="Fecha de carga"
                    required>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="virtualCard.primary_email_notification"
                    :rules= emailRules
                    label="E-mail principal"
                  ></v-text-field>
                </v-col>

                  <v-col col="12" md="3">
                      <v-autocomplete
                              v-model="virtualCard.security_context_id"
                              :rules="[v => !!v || 'Seleccione una plataforma']"
                              :items="security_context"
                              item-text="name"
                              item-value="id"
                              label="Plataforma"
                              required>

                          <template v-slot:no-data>
                              <div class="px-4" >Plataforma no encontrada</div>
                          </template>
                      </v-autocomplete>
                  </v-col>
              </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Guardar
                </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <messageComponent ref="message"></messageComponent>
    </div>
</template>

<script>

  import axios from 'axios';
  import messageComponent from './MessageComponent';
  import getBaseUrl from '../utils/baseUrl';

  const intervalDefault = 30;

	export default{

		name:"FrmVCConfigComponent",
		data(){
			return {
        virtualCard:{
          id:0,
          billing_provider_id:0,
          owner_company_id: 0,
          currency:'EUR',
          vendor_code:'',
          type:'',
          validity_period_start_type:0,
          validity_period_end_type:0,
          validity_end_interval: intervalDefault,
          cancellation_type:0,
          primary_email_notification:'',
          charge_date_type: 0,
          security_context_id: 0
        },
        companyName: null,
        editedIndex: -1,
        valid: true,
				dialog: false,
				dialogDelete: false,
        loading:false,
                providers:[],
				cancellations:[],
				companies:[],
				vendors_code:[],
				vendor_types:{},
                security_context:[],
        card_types: [],
				currencies:[],
				itemsValidityStart:[],
                itemsValidityEnd:[],
                chargeDateType:[],
        emailRules: [
          v => !v || /.+@.+\..+/.test(v) || 'Debe ser un email valido',
        ]
      }
    },

		computed:{
			formTitle () {
				return this.editedIndex === -1 ? 'Nueva configuracion de tarjeta' : 'Editar configuracion tarjeta'
			},
		},

		mounted(){

      this.getInitialize()
		},

		methods: {

      getInitialize(){

        axios.get(`${getBaseUrl()}default`)
          .then(res =>{
            this.companies = res.data.data.owner_companies;
            this.companyName = res.data.data.owner_companies.name;
            this.providers = res.data.data.providers;
            this.security_context = res.data.data.security_context;

          for(let i in res.data.data.cancellation_type){
              this.cancellations.push({ name : res.data.data.cancellation_type[i], id: i });
          }

          for(let i in res.data.data.currencies){

              this.currencies.push({ name : res.data.data.currencies[i], id: i });
          }

          for(let i in res.data.data.validity_type_start){
              this.itemsValidityStart.push({ name : res.data.data.validity_type_start[i], id: i });
          }

          for(let i in res.data.data.validity_type_end){
            this.itemsValidityEnd.push({ name : res.data.data.validity_type_end[i], id: i });
          }

          for(let i in res.data.data.charge_date_type){
            this.chargeDateType.push({ name : res.data.data.charge_date_type[i], id: i });
          }

          for(let i in res.data.data.vendors_code){
              this.vendors_code.push({ name : res.data.data.vendors_code[i], id: i });
          }

          this.virtualCard.owner_company_id = this.companies.id;

          for (let index in res.data.data.vendor_types) {
            let types = res.data.data.vendor_types[index];
            this.vendor_types[index] = [];
            for(let i in types){
              this.vendor_types[index].push({ name : types[i], id: types[i] });
            }
          }

          this.defaultValues();
        });
      },

      close () {
        this.dialog = false;
        this.$refs.form.reset();
        this.$nextTick(() =>{
          this.defaultValues();
        });
      },

      editItem (item) {

          this.dialog = true;
          this.loadingActive();

          let itemId = item.id;
          this.editedIndex = itemId;
          axios.get(`${getBaseUrl()}edit`,{
              params: {
                id: itemId
              }
            })
            .then(res =>{

                this.virtualCard = res.data.data;
                this.virtualCard.billing_provider_id = parseInt(res.data.data.billing_provider_id);

            }).catch(error => {

                this.messageInfo("¡Atención! configuracion no guardada");

            }).finally(()=>{
                this.loadingActive();
            });
      },

      save(){

        if(this.$refs.form.validate()){

          this.loadingActive();

          axios.post(`${getBaseUrl()}save`,this.virtualCard)
            .then(res =>
              {

                if(res.status == 200){

                    this.messageInfo("¡Configuracion guardada con exito!");
                    this.updateList();
                }

              }).catch(error => {

                this.messageInfo("¡Atención! configuracion no guardada");

            }).finally(()=>{

                this.loadingActive();
            });

              this.close();
        }
      },

      messageInfo(text){

          this.$refs.message.activate(text);
      },

      updateList(){

          this.$emit('updateList');
      },

      defaultValues(){

          this.editedIndex = -1;
          this.virtualCard.id = 0;
          this.virtualCard.validity_end_interval = intervalDefault;
          this.virtualCard.currency = 'EUR';
          this.virtualCard.validity_period_start_type = this.itemsValidityStart[0].id;
          this.virtualCard.validity_period_end_type = this.itemsValidityEnd[0].id;
          this.virtualCard.charge_date_type = this.chargeDateType[1].id;
          this.virtualCard.primary_email_notification = '';
          this.virtualCard.secundary_email_notification = '';
      },

      loadingActive(){

          this.$emit('changLoading');
      },

      loadCurrency(){

        this.loadingActive();
        axios.get(`${getBaseUrl()}paymentprov`,{
              params: {
                id: this.virtualCard.billing_provider_id
              }
            })
            .then(res =>{

                let itemData = res.data.data;
                this.virtualCard.currency = itemData.payment_currency

            }).catch(error => {

                this.messageInfo("¡Atención! configuracion no guardada");

            }).finally(()=>{

                this.loadingActive();
            });

      },

        loadProvidersVCC(){

            this.loadingActive();
            axios.get(`${getBaseUrl()}providersvcc`,{
                params: {
                    id: this.virtualCard.owner_company_id
                }
            })
                .then(res =>{

                    this.providers = res.data.data.providers;

                }).catch(error => {

                this.messageInfo("¡Atención! No hay proveedores de pago válidos");

            }).finally(()=>{

                this.loadingActive();
            });
        },

      updateCardTypes(vendorCode) {
        this.card_types = this.vendor_types[vendorCode];
      }
		},
    components:{
        messageComponent
    },
    watch: {
      virtualCard: {
        deep: true,
        handler(newVirtualCard) {
          this.updateCardTypes(newVirtualCard.vendor_code);
        }
      }
    }
	}
</script>